module.exports = {
      id: "clapboard-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#clapboard",
      toString: function () {
        return this.url;
      }
    }